import React from 'react'
import { isSjDomain , isKsDomain } from 'utils/domain'

import SjGlobalFooter from './SjGlobalFooter'
import KsGlobalFooter from './KsGlobalFooter'

/**
 * グローバルフッター・全ての画面に適用するフッター
 */
const GlobalFooterArea: React.FC = () => {
  return <React.Fragment>{isSjDomain() && <SjGlobalFooter />}{isKsDomain() && <KsGlobalFooter />}</React.Fragment>
}

export default GlobalFooterArea
